var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, action, runInAction } from "mobx";
import $http, { Q } from "@http";
import { isEmpty } from "lodash";
var DuplicateCheckStore = /** @class */ (function () {
    function DuplicateCheckStore() {
        this.duplicateEnvToggle = false;
        this.originWO = {};
        this.duplicateWOList = [];
        this.screenWidth = 0;
        this.screenLimit = 0;
        this.loading = false;
    }
    DuplicateCheckStore.prototype.getDuplicateEnvToggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getDuplicateEnvToggle();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.duplicateEnvToggle = data.body;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DuplicateCheckStore.prototype.setLoading = function (flag) {
        this.loading = flag;
    };
    DuplicateCheckStore.prototype.setScreenWidth = function (value) {
        this.screenWidth = value;
        if (value < ScreenWidth.MobileLimit) {
            this.screenLimit = AttachmentLimit.Mobile;
        }
        else {
            this.screenLimit = AttachmentLimit.Other;
        }
    };
    DuplicateCheckStore.prototype.setOriginWO = function (wo) {
        this.originWO = new OriginWOViewModel(wo);
    };
    DuplicateCheckStore.prototype.uploadAttachment = function (file, wo) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        return [4 /*yield*/, this.api().uploadFiles(formData).then(function (data) {
                                runInAction(function () {
                                    var _a;
                                    if (data && typeof data !== 'string') {
                                        var attach = {
                                            fileName: data.fileName,
                                            filePath: data.url,
                                            fileUrl: data.fileUrl,
                                            contentType: ((_a = file === null || file === void 0 ? void 0 : file.name) === null || _a === void 0 ? void 0 : _a.includes('.hevc')) ? 'video/x-matroska' : file.type,
                                            thumbnailPath: data.downUrl,
                                        };
                                        wo.attachments.push(attach);
                                    }
                                });
                                return data && typeof data !== 'string' ? true : false;
                            }).catch(function () {
                                return false;
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    DuplicateCheckStore.prototype.deleteAttachment = function (index, wo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wo.attachments.splice(index, 1);
                        return [4 /*yield*/, this.setOriginWO(wo)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DuplicateCheckStore.prototype.submit = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().recordDuplicateWO(params);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    DuplicateCheckStore.prototype.getDuplicateWOList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getReactiveWoDuplicateWoList(params);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data && data.isSuccess) {
                                _this.duplicateWOList = data.body;
                                _this.computeDuplicateWOList(data.body);
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    DuplicateCheckStore.prototype.computeDuplicateWOList = function (woList) {
        var _this = this;
        if (isEmpty(woList)) {
            return;
        }
        var list = woList.map(function (wo) {
            wo.attachmentShowAll = wo.attachmentShowAll ? wo.attachmentShowAll : false;
            _this.computeAliasOrServiceComboName(wo);
            _this.computeDuplicateWOAttachment(wo);
            return wo;
        });
        this.duplicateWOList = list;
    };
    DuplicateCheckStore.prototype.computeAliasOrServiceComboName = function (wo) {
        var tempName = '';
        if (wo.serviceCombinationAliasId) {
            tempName = this.computeAliasName(wo);
        }
        else {
            tempName = wo.serviceCombination.serviceCategoryName + " > " + wo.serviceCombination.serviceTypeName + " > " + wo.serviceCombination.serviceCodeName;
        }
        wo.aliasOrServiceComboName = tempName;
    };
    DuplicateCheckStore.prototype.computeAliasName = function (wo) {
        var tempName = '';
        if (wo.serviceCombinationAlias.serviceCodeAliasId) {
            tempName = wo.serviceCombinationAlias.serviceCategoryAliasName + " > " + wo.serviceCombinationAlias.serviceTypeAliasName + " > " + wo.serviceCombinationAlias.serviceCodeAliasName;
        }
        else {
            tempName = wo.serviceCombinationAlias.serviceCategoryAliasName + " > " + wo.serviceCombinationAlias.serviceTypeAliasName;
        }
        return tempName;
    };
    DuplicateCheckStore.prototype.computeDuplicateWOAttachment = function (wo) {
        if (this.screenWidth < ScreenWidth.MobileLimit) {
            if (wo.attachments.length > 0 && wo.attachments.length <= 4) {
                wo.tempAttachments = wo.attachments;
            }
            else if (wo.attachments.length > 4) {
                var woAttachmentList = wo.attachments.concat();
                wo.attachmentShowAll ? wo.tempAttachments = woAttachmentList : wo.tempAttachments = woAttachmentList.splice(0, 4);
            }
        }
        else {
            if (wo.attachments.length > 0 && wo.attachments.length <= 3) {
                wo.tempAttachments = wo.attachments;
            }
            else if (wo.attachments.length > 3) {
                var woAttachmentList = wo.attachments.concat();
                wo.attachmentShowAll ? wo.tempAttachments = woAttachmentList : wo.tempAttachments = woAttachmentList.splice(0, 3);
            }
        }
    };
    DuplicateCheckStore.prototype.toggleWOAttachmentShow = function (wo, flag) {
        var tempWO = JSON.parse(JSON.stringify(wo));
        tempWO.attachmentShowAll = flag;
        this.computeDuplicateWOAttachment(tempWO);
        var index = this.duplicateWOList.findIndex(function (x) { return x.woId === wo.woId; });
        if (index > -1) {
            this.duplicateWOList.splice(index, 1, tempWO);
        }
    };
    DuplicateCheckStore.prototype.api = function () {
        return {
            uploadFiles: function (param) {
                return Q($http.post("/RSP/File/UploadRSP", param));
            },
            getDuplicateEnvToggle: function () {
                return Q($http.get("/RSP/NewRequest/IsDevOrStageEnvironment"));
            },
            recordDuplicateWO: function (param) {
                return Q($http.post("/RSP/NewRequest/RecordDuplicateWO", param));
            },
            getReactiveWoDuplicateWoList: function (params) {
                return Q($http.get("/RSP/NewRequest/GetReactiveWoDuplicateWoList", { params: params }));
            }
        };
    };
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "duplicateEnvToggle", void 0);
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "originWO", void 0);
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "duplicateWOList", void 0);
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "screenWidth", void 0);
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "screenLimit", void 0);
    __decorate([
        observable
    ], DuplicateCheckStore.prototype, "loading", void 0);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "getDuplicateEnvToggle", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "setLoading", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "setScreenWidth", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "setOriginWO", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "uploadAttachment", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "deleteAttachment", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "submit", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "getDuplicateWOList", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "computeDuplicateWOList", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "computeDuplicateWOAttachment", null);
    __decorate([
        action.bound
    ], DuplicateCheckStore.prototype, "toggleWOAttachmentShow", null);
    return DuplicateCheckStore;
}());
export default DuplicateCheckStore;
var ScreenWidth;
(function (ScreenWidth) {
    ScreenWidth[ScreenWidth["MobileLimit"] = 768] = "MobileLimit";
})(ScreenWidth || (ScreenWidth = {}));
var AttachmentLimit;
(function (AttachmentLimit) {
    AttachmentLimit[AttachmentLimit["Mobile"] = 4] = "Mobile";
    AttachmentLimit[AttachmentLimit["Other"] = 3] = "Other";
})(AttachmentLimit || (AttachmentLimit = {}));
var OriginWOViewModel = /** @class */ (function () {
    function OriginWOViewModel(data) {
        this.additionalDetail = data ? data.additionalDetail : null;
        this.woStatusId = data ? data.woStatusId : null;
        this.woId = data ? data.woId : null;
        this.woNum = data ? data.woNum : null;
        this.serviceCombinationAliasId = data ? data.serviceCombinationAliasId : null;
        this.serviceCombinationAlias = data ? data.serviceCombinationAlias : {};
        this.serviceCombination = data ? data.serviceCombination : {};
        this.attachments = data ? data.attachments : [];
        this.createDate = data ? data.createDate : null;
        this.tempAttachments = data ? data.tempAttachments : [];
        this.attachmentShowAll = data ? data.attachmentShowAll : false;
        this.aliasOrServiceComboName = data ? data.aliasOrServiceComboName : null;
    }
    return OriginWOViewModel;
}());
export { OriginWOViewModel };
